"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SimpleSelectButton_component_exports = {};
__export(SimpleSelectButton_component_exports, {
  SimpleSelectButton: () => SimpleSelectButton
});
module.exports = __toCommonJS(SimpleSelectButton_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = __toESM(require("react"));
var import_Button = require("../Button/Button.component");
var import_Plus = __toESM(require("@greatmindsorg/gmui-icons-lib/dist/Plus"));
var import_clsx = __toESM(require("clsx"));
const SimpleSelectButton = import_react.default.forwardRef(
  ({ placeholder, getReferenceProps, id, as }, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
      import_Button.Button,
      __spreadProps(__spreadValues({
        as,
        variant: "primary",
        size: "medium",
        className: (0, import_clsx.default)("flex h-[40px] w-full flex-row items-center py-xs"),
        "data-testid": "simple-select-button",
        "aria-labelledby": "simple-select-label",
        type: "button",
        id
      }, getReferenceProps()), {
        ref,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Button.Button.Icon, { position: "left", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Plus.default, { title: "", iconSize: "s", color: "white", "aria-hidden": true }) }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
            import_Button.Button.Label,
            {
              className: (0, import_clsx.default)(
                "text-[--color-content-interactive-prim]",
                "font-[--font-family-body]",
                "text-[--font-size-base]",
                "font-normal",
                "whitespace-nowrap",
                "overflow-hidden",
                "text-ellipsis",
                "max-w-[120px]"
              ),
              id: "simple-select-label",
              children: placeholder
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "flex-grow" })
        ]
      })
    );
  }
);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  SimpleSelectButton
});
//# sourceMappingURL=SimpleSelectButton.component.js.map